export default "__VITE_ASSET__Dx31Liv1__"